export default {
  // 定数が必要な場合設定する
  LIMIT: 2000,
  PAGE: 1,
}
